import { css } from '@emotion/css';

export const renderInputStyles = css`
  border: none;
  min-height: unset;
  padding-inline-end: 0 !important;
  padding-inline-start: 0.8rem;

  .MuiInputBase-input {
    height: 2.6rem;
    min-width: unset;
  }

  :focus-within {
    width: 100%;
  }
`;
